import { formURL } from "Utils/CommonUtilities";
import BaseApiRequest from "./BaseApiRequest";
import { FINANCIALANALYSYS_LIST_URL } from "../ApiUrls";
import { METHOD } from "../Constants";

export default class GetFinancialAnalysisList extends BaseApiRequest {
  method = METHOD.HTTP.GET;

  body = [];

  url = FINANCIALANALYSYS_LIST_URL;

  constructor(applicantId) {
    super();
    const paramList = [applicantId];
    this.url = formURL(this.url, paramList);
  }

  getMethod = () => {
    return this.method;
  };

  getUrl = () => {
    return this.url;
  };

  getBody = () => {
    return this.body;
  };
}
